export const BASE_URL = "";
export const CAPTCHA_URL = "/web/api/v1/otps";